class PageNavigation extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this?.els?.current?.exists) {
      this.els.current.element.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      })
    }
  }
}

if (!customElements.get('page-navigation')) {
  customElements.define('page-navigation', PageNavigation)
}
